import { render, staticRenderFns } from "./OnlineStructDetail.vue?vue&type=template&id=7d20dca6&"
import script from "./OnlineStructDetail.vue?vue&type=script&lang=js&"
export * from "./OnlineStructDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OnlineStructDetail.vue"
export default component.exports